import * as bulletin from './bulletin';
import * as vehSystems from './vehSystems';
import * as bulletinQuery from './query';
import * as vehicleQuery from './vehicleQuery';

const reducers = {
  ...vehicleQuery,
  ...bulletinQuery,
  ...vehSystems,
  ...bulletin,
};

export default reducers;
